var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.classes,attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function () {
    _vm.$emit('update:refresh', true)
    _vm.$nextTick(function () {
      // reset refresh
      _vm.$emit('update:refresh', false)
    })
  }}},[_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":"RefreshCcwIcon"}}),_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }